import React from "react";
import axios from "axios";
import ProfilePic from "../Layout/ProfilePic";

const VIDEO_UPDATE_URL =
  "https://rkpf1ewcje.execute-api.us-west-2.amazonaws.com";


class Comment extends React.Component {
  state = { text: "" };

  render() {
    return (
      <div className="flex-row mt-3">
        <ProfilePic user={this.props.pub_user} lg />
        <div className="flex-row flex-1" style={{ alignItems: "center" }}>
          <input
            name={Math.random().toFixed(10)}
            className="comment ml-3 flex-1"
            placeholder="Add Comment..."
            value={this.state.text}
            type="text"
            id="comment"
            onChange={(e) => {
              this.setState({ text: e.target.value });
            }}
          />
          <button
            className="comment-btn float-right ml-3 text-white"
            style={{ backgroundColor: this.props.color }}
            onClick={async () => {
              if (this.state.text !== "") {
                if (this.props.type === "live") {
                  let { data } = await axios.post(
                    VIDEO_UPDATE_URL +
                      "/live/" +
                      this.props.video._id +
                      "/add-comment",
                    {
                      comment: {
                        text: this.state.text,
                        user: this.props.pub_user._id,
                      },
                    }
                  );
                  if (data.nModified) {
                    this.props.add(this.state.text);
                    this.setState({ text: "" });
                  }
                } else {
                  let { data } = await axios.post(
                    VIDEO_UPDATE_URL +
                      "/file/" +
                      this.props.video._id +
                      "/add-comment",
                    {
                      comment: {
                        text: this.state.text,
                        user: this.props.pub_user._id,
                      },
                    }
                  );
                  if (data.nModified) {
                    this.props.add(this.state.text);
                    this.setState({ text: "" });
                  }
                }
              }
            }}
          >
            Comment
          </button>
        </div>
      </div>
    );
  }
}
export default Comment;
